import React from "react";
import { Form, Grid, Segment,   Button, Message, Icon, Tab } from 'semantic-ui-react'
import TextBox from "../containers/TextBox"
import DropDown from "../containers/DropDown"
import CheckBox from "../containers/CheckBox"
import DatePickerHTML from "../containers/DatePickerHTML"
import DateTimePickerHTML from "../containers/DateTimePickerHTML"
import TimePickerHTML from "../containers/TimePickerHTML"
import NumberBox from "../containers/NumberBox"

export function rendersubcomponents(component, statevar, setvaluefunction, setaddressfunction, parameters={}, data={}, refreshfunction=null)
{
  //console.log(component)
  var subcomponents=[]
   if('components' in component)
  {
      subcomponents=component['components']
  
  }
  //let _this=this;
  const rendersubcomponents=subcomponents.map((subc, i)=>{return(rendercomponent(subc, statevar, setvaluefunction, setaddressfunction, parameters, data, refreshfunction))})
  return(rendersubcomponents)
  //return [{}].concat(subcomponents).map(subcomponent=>{parent.rendercomponent(subcomponent)})
}

export function rendercomponent(component, statevar, setvaluefunction, setaddressfunction, parameters={}, data={}, refreshfunction=null)
{
  const type=component['type'];
  const field=component['field'];
  const fieldname=component['fieldname'];
  //const value=statevar[fieldname]
  var componentrender
  var enabled=true
  if ('enabled' in component)
  {
    enabled=component.enabled;
  }
  if ('enabledfield' in component)
  {
    if ('enabledvalue' in component)
    {
      enabled=statevar[component.enabledfield===component.enabledvalue];
    }
    else
    {
      enabled=statevar[component.enabledfield];
    }
    
  }
  if ('enabled' in component)
  {
    enabled=component.enabled;
  }
  if ('enabledfield' in component)
  {
    if ('enabledvalue' in component)
    {
      enabled=statevar[component.enabledfield===component.enabledvalue];
    }
    else
    {
      enabled=statevar[component.enabledfield];
    }
    
  }
    if(type==='Form')
    {
        var title=''
        if('titlefield' in component) title='- ' + statevar[component.titlefield]

        componentrender=
        <Grid.Row className="header"> 
        <Segment basic className="header"><Form>  
          <h2><Icon color="blue" name={statevar.viewdefinition.icon}/>{statevar.viewdefinition.title} {this.props.match.params.id} {title}</h2>
          {/* <Label><Icon name={statevar.viewdefinition.icon}/>{this.props.match.params.viewname} {this.props.match.params.id}</Label> */}
          <Grid columns={component['columns']}>
          {rendersubcomponents(component)}</Grid>
        <Message
          success
          visible={statevar.submitSuccess}
          header='Changes Saved'
          content="The data was updated successfully"
        />
        <Message
          error
          visible={statevar.submitFailed}
          header="Data update failed"
          list={statevar.validationErrors}
        />

        </Form>
        </Segment>
        <Segment basic>
        <Button className='seaglassbutton' loading={statevar.isSubmitting} disabled={!statevar.formValid} onClick={this.saveChanges}>Save</Button>
        </Segment>
        </Grid.Row>
    }
    else if(type==='Column')
    {
        var width=3;
        if('width' in component) width=component.width
        componentrender=<Grid.Column width={width}>{rendersubcomponents(component)}</Grid.Column>

    }


  else if(type==='Container')
  {
      componentrender=<div>{rendersubcomponents(component, statevar, setvaluefunction, setaddressfunction)}</div>
  }
  else if(type==='TextBox')
  {
    componentrender=<TextBox key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} onChange={setvaluefunction} enabled={enabled}/>
     
  } 
  else if(type==='NumberBox')
  {
    componentrender=<NumberBox key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} onChange={setvaluefunction} enabled={enabled}/>
     
  }     
  else if(type==='DropDown')
  {
    const values=component['values'];
  // componentrender=<DropDown key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} values={values} onChange={setvaluefunction}/>
  if ('filterfields' in field)
  {
    const filtervalue=field.filterfields.map(fieldname=>{return statevar[fieldname]}).join("_")
    componentrender=<DropDown key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} values={values} filtervalue={filtervalue} onChange={setvaluefunction} enabled={enabled}/>
  }
  else 
  {
    componentrender=<DropDown key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} values={values} onChange={setvaluefunction} enabled={enabled}/>
  }  
  }
  else if(type==='DatePicker')
  {
    //componentrender=<DatePicker key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} onChange={setvaluefunction}/>
    componentrender=<DatePickerHTML key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} onChange={setvaluefunction} enabled={enabled}/>
  }
  else if(type==='DateTimePicker')
  {
    //componentrender=<DatePicker key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} onChange={setvaluefunction}/>
    componentrender=<DateTimePickerHTML key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} onChange={setvaluefunction} enabled={enabled}/>
  }
  else if(type==='TimePicker')
  {
    //componentrender=<DatePicker key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} onChange={setvaluefunction}/>
    componentrender=<TimePickerHTML key={fieldname} fieldname={fieldname} field={field} value={statevar[fieldname]} showlabel={component['label']} onChange={setvaluefunction} enabled={enabled}/>
  }
  else if(type==='CheckBox')
  {
    componentrender=<CheckBox key={fieldname} field={field} value={statevar[fieldname]} onChange={(event, data)=>{setvaluefunction(fieldname, field, data.checked)}} enabled={enabled}/>
     
  }
  ;

  return(componentrender);
}
